import { Box } from '~/commonComponents';
import { Tab, TabList, Tabs } from '~/commonComponents/Tabs';
import { Colors } from '~/themes/colors';
import { WorkingInterviewStatus } from '../../utils';

const TitleCopy = {
  [WorkingInterviewStatus.ActionNeeded]: 'Action Needed',
  [WorkingInterviewStatus.Cancelled]: 'Cancelled & Expired',
  [WorkingInterviewStatus.Completed]: 'Completed',
  [WorkingInterviewStatus.Open]: 'Open',
  [WorkingInterviewStatus.Scheduled]: 'Scheduled',
};

const DotColors = {
  [WorkingInterviewStatus.ActionNeeded]: Colors.error_450,
  [WorkingInterviewStatus.Cancelled]: Colors.warning_500,
  [WorkingInterviewStatus.Completed]: Colors.neutral_400,
  [WorkingInterviewStatus.Open]: Colors.success_500,
  [WorkingInterviewStatus.Scheduled]: Colors.secondary_500,
};

interface IWorkingInterviewStatusFilterPanelProps {
  counts: Record<WorkingInterviewStatus, number>;
  onChange(tab: WorkingInterviewStatus | 'all'): void;
}

export const WorkingInterviewStatusFilterPanel = ({
  counts,
  onChange,
}: IWorkingInterviewStatusFilterPanelProps) => {
  const tabs = [
    WorkingInterviewStatus.ActionNeeded,
    WorkingInterviewStatus.Open,
    WorkingInterviewStatus.Scheduled,
    WorkingInterviewStatus.Completed,
    WorkingInterviewStatus.Cancelled,
  ];
  const totalCount = Object.values(counts).reduce((sum, count) => sum + count, 0);

  const handleTabChange = (idx: number) => {
    onChange(tabs[idx - 1] || 'all');
  };

  return (
    // @ts-expect-error JS Component
    <Tabs tabListStyle={{ gap: 16 }} onChangeTab={handleTabChange}>
      {/* @ts-expect-error JS Component */}
      <TabList>
        {/* @ts-expect-error JS Component */}
        <Tab
          title={`All Active${totalCount > 0 ? ` (${totalCount})` : ''}`}
          textStyle={{
            fontSize: 20,
          }}
        />
        {tabs.map((it) => (
          // @ts-expect-error JS Component
          <Tab
            PrefixComponent={
              <Box backgroundColor={DotColors[it]} borderRadius="100%" height={10} width={10} />
            }
            key={it}
            title={`${TitleCopy[it]}${counts[it] > 0 ? ` (${counts[it]})` : ''}`}
            textStyle={{
              fontSize: 20,
            }}
          />
        ))}
      </TabList>
    </Tabs>
  );
};
